import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SeoCanonical() {
  const location = useLocation();

  const canonicalUrl = `https://selsmart.in${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}